export default __webpack_public_path__ + "static/media/pyposition_84b.5e02caa7.png";